/**
 * Status Info Content Component
 *
 * Displays the status explanation overlay content showing
 * what each invitation status means with visual indicators.
 */

import React from 'react';

import StatusIndicator from '../../StatusIndicator';

import './style.scss';

interface StatusInfoContentProps {
  /** Translation function */
  t: (key: string) => string;
}

/**
 * Renders the status information overlay content
 */
const StatusInfoContent: React.FC<StatusInfoContentProps> = ({ t }) => (
  <div className="StatusInfoContent">
    <div className="StatusInfoContent__item">
      <StatusIndicator status="invited" />
      <p>{t('mijn_vnl.orders.status_invited_description')}</p>
    </div>
    <div className="StatusInfoContent__item">
      <StatusIndicator status="started" />
      <p>{t('mijn_vnl.orders.status_started_description')}</p>
    </div>
    <div className="StatusInfoContent__item">
      <StatusIndicator status="finished" />
      <p>{t('mijn_vnl.orders.status_finished_description')}</p>
    </div>
  </div>
);

export default StatusInfoContent;
